export enum FormInputModifier {
  INVERTED = 'inverted',
}
